import React, { useContext, useEffect } from "react";
import {
  Container,
  Col,
  Button,
  Form,
  Row,
  Spinner,
  Card,
} from "react-bootstrap";
// import { Zoom } from "react-awesome-reveal";
import { Link } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import ApiAccount from "../../../core/api/api.account";
import ContextApp from "../../../core/contexts/context.app";
// import useLoginModal from '../../../core/hooks/useLoginModal';
import { PatternFormat } from "react-number-format";
import { toast, ToastContainer } from "react-toastify";
import { isMobile } from "react-device-detect";
import _ from "lodash";
import cardImage from "../../../assets/images/refund.svg";

function Refund() {
  //const { register, handleSubmit, control, setValue, formState: { errors }, reset } = useForm({ defaultValues: { accountNumber: "1234567890", ss: 3 } });
  const {
    register,
    handleSubmit,
    control,
    setValue,
    formState: { errors, isSubmitting },
    reset,
  } = useForm();
  const ctx = useContext(ContextApp);
  // const [Modali, setShow] = useLoginModal();

  useEffect(() => {
    if (ctx.isAuth) {
      // setTimeout(() => reset({ ss: 4, accountNumber:"1234567899" }), 2000);
      // اگر قرار است دیتای اولیه ای از سرور بیاورد اینجا به صورت بالا استفاده میکنیم
    } else {
      
    }
  }, [ctx.isAuth]);

  const onSubmit = async (data) => {
    try {
      data.accountOwnerName = data.cardOwnerName;
      data.cardNumber = data.cardNumber.split(" ").join("").split("-").join("");
      const response = await ApiAccount.createAccount(data);
      
      if (
        !_.isEmpty(response) &&
        response.data !== undefined &&
        response.data > 0
      ) {
        // toast.configure();
        toast(response.message);
        reset({}); //کار نمیکند
      }
    } catch (error) {
      
    }
  };

  const ff = {
    bank: register("bank", { required: true }),
    accountNumber: register("accountNumber"),
    cardOwnerName: register("cardOwnerName", { required: true }),
    cardNumber: register("cardNumber", {
      required: true,
      maxLength: 25,
      minLength: 25,
    }),
    shebaNumber: register("shebaNumber", {
      required: true,
      maxLength: 24,
      minLength: 24,
    }),
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <ToastContainer position="top-center" rtl="true"></ToastContainer>
      {isMobile ? (
        /* ********حالت موبایل****************************************** */
        <Container fluid className="main-content transaction-box">
          <Col xs={12}>
            <Row className="py-1">
              <Col xs={12} className="my-auto pr-2 pl-0">
                {/* <Modali /> */}
              </Col>
            </Row>
          </Col>

          <Col xs={12} className="  mt-3 ">
            <Card className="rounded-3">
              <Card.Body>
                <Link
                  to="/wallet"
                  className=" d-block text-dark border-bottom w-100 pb-2 mb-3 text-center"
                >
                  <h3 className="my-auto d-inline-block fs-normal">
                    {" "}
                    درج اطلاعات حساب
                  </h3>
                </Link>
                <div className="text-black-06 fs-09 mb-4 text-center">
                  لطفا فرم زیر را کامل نمایید.{" "}
                </div>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <Form.Control
                    {...ff.bank}
                    type="text"
                    className="mb-2  text-center"
                    placeholder="نام بانک"
                  />
                  {errors.bank && (
                    <div className="text-danger text-center fs-085 mb-3">
                      نام بانک نمیتواند خالی باشد
                    </div>
                  )}
                  <Form.Control
                    {...ff.accountNumber}
                    type="number"
                    className="mb-2 ltr text-center"
                    placeholder="شماره حساب"
                  />
                  <Form.Control
                    {...ff.cardOwnerName}
                    type="text"
                    className="mb-2  text-center"
                    placeholder="نام صاحب کارت"
                  />
                  {errors.cardOwnerName && (
                    <div className="text-danger text-center fs-085 mb-3">
                      نام صاحب کارت نمیتواند خالی باشد
                    </div>
                  )}
                  <Controller
                    name="cardNumber"
                    control={control}
                    rules={{ required: true, maxLength: 25, minLength: 25 }}
                    render={({ field: { onChange, value } }) => (
                      <PatternFormat
                        format="#### - #### - #### - ####"
                        mask=""
                        type="text"
                        name="cardNumber"
                        className="form-control mb-2 ltr  text-center"
                        placeholder="شماره کارت"
                        value={value || ""}
                        onChange={onChange}
                      />
                    )}
                  />
                  {/* <NumberFormat className="form-control mb-2 ltr" format="#### - #### - #### - ####" mask=""
                            {...ff.cardNumber}
                            placeholder="شماره کارت"
                        /> */}
                  {errors.cardNumber?.type === "required" && (
                    <div className="text-danger text-center fs-085 mb-3">
                      شماره کارت نمیتواند خالی باشد
                    </div>
                  )}
                  {errors.cardNumber?.type === "minLength" && (
                    <div className="text-danger text-center fs-085 mb-3">
                      شماره کارت باید 16 رقم باشد
                    </div>
                  )}
                  <Form.Group>
                    <div className="d-flex">
                      <Form.Control
                        {...ff.shebaNumber}
                        onKeyPress={(e) => {
                          if (e.target.value.length === 24) {
                            e.preventDefault();
                          }
                        }}
                        type="number"
                        className="mb-2 ltr text-center border-end-0 rounded-end-0"
                        placeholder="شماره شبا"
                      />
                      <Form.Control
                        style={{ width: "25px" }}
                        disabled
                        className="form-control border-start-0 text-black mb-2 bg-white mb-2 rounded-start-0 ps-0 pe-1"
                        value="-IR"
                      />
                    </div>

                    {errors.shebaNumber?.type === "required" && (
                      <div className="text-danger text-center fs-085 mb-3">
                        شماره شبا نمیتواند خالی باشد
                      </div>
                    )}
                    {errors.shebaNumber?.type === "minLength" && (
                      <div className="text-danger text-center fs-085 mb-3">
                        شماره شبا باید 24 کاراکتر باشد
                      </div>
                    )}
                  </Form.Group>

                  <Button
                    variant="primary"
                    type="submit"
                    disabled={isSubmitting}
                    className="w-100 rounded-2"
                  >
                    {isSubmitting && (
                      <Spinner animation="border" variant="warning" size="sm" />
                    )}
                    ذخیره
                  </Button>
                  <Link
                    to="/wallet"
                    className="btn btn-outline-primary w-100 rounded-2 mt-2 mb-3"
                  >
                    بازگشت به صفحه قبل
                  </Link>
                </form>
              </Card.Body>
            </Card>
          </Col>
        </Container>
      ) : (
        /* ********حالت دسکتاپ****************************************** */
        <Container fluid className="main-content bg-light-3 ">
          <Container className="py-4 ">
            <Link
              to="/wallet"
              className=" d-block text-dark pb-2 mb-3 text-center"
            >
              {/* <ArrowRightShort size={25} /> */}
            </Link>

            <Card className="rounded-3">
              <Card.Body>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <Row className="">
                    <Col md="5">
                      <div>
                        <h3 className="my-auto d-inline-block fs-101">
                          درج اطلاعات حساب
                        </h3>
                        <div className="d-inline-block text-black-06 fs-085 mb-4 ms-2 ">
                          لطفا فرم زیر را کامل نمایید.
                        </div>
                      </div>
                      <Form.Control
                        {...ff.bank}
                        type="text"
                        className="mb-2  text-center"
                        placeholder="نام بانک"
                      />
                      {errors.bank && (
                        <div className="text-danger text-center fs-085 mb-3">
                          نام بانک نمیتواند خالی باشد
                        </div>
                      )}

                      <Form.Control
                        {...ff.cardOwnerName}
                        type="text"
                        className="mb-2  text-center"
                        placeholder="نام صاحب کارت"
                      />
                      {errors.cardOwnerName && (
                        <div className="text-danger text-center fs-085 mb-3">
                          نام صاحب کارت نمیتواند خالی باشد
                        </div>
                      )}

                      <Form.Control
                        {...ff.accountNumber}
                        type="number"
                        className="mb-2 ltr text-center"
                        placeholder="شماره حساب"
                      />

                      <Controller
                        name="cardNumber"
                        control={control}
                        rules={{ required: true, maxLength: 25, minLength: 25 }}
                        render={({ field: { onChange, value } }) => (
                          <PatternFormat
                            format="#### - #### - #### - ####"
                            mask=""
                            type="text"
                            name="cardNumber"
                            className="form-control mb-2 ltr  text-center"
                            placeholder="شماره کارت"
                            value={value || ""}
                            onChange={onChange}
                          />
                        )}
                      />
                      {/* <NumberFormat className="form-control mb-2 ltr" format="#### - #### - #### - ####" mask=""
                            {...ff.cardNumber}
                            placeholder="شماره کارت"
                        /> */}
                      {errors.cardNumber?.type === "required" && (
                        <div className="text-danger text-center fs-085 mb-3">
                          شماره کارت نمیتواند خالی باشد
                        </div>
                      )}
                      {errors.cardNumber?.type === "minLength" && (
                        <div className="text-danger text-center fs-085 mb-3">
                          شماره کارت باید 16 رقم باشد
                        </div>
                      )}

                      <Form.Group>
                        <div className="d-flex">
                          <Form.Control
                            {...ff.shebaNumber}
                            onKeyPress={(e) => {
                              if (e.target.value.length === 24) {
                                e.preventDefault();
                              }
                            }}
                            type="number"
                            className="mb-2 ltr text-center border-end-0 rounded-end-0"
                            placeholder="شماره شبا"
                          />
                          <Form.Control
                            style={{ width: "35px" }}
                            disabled
                            className="form-control border-start-0 text-black mb-2 bg-white mb-2 rounded-start-0 ps-0 pe-2"
                            value="-IR"
                          />
                        </div>

                        {errors.shebaNumber?.type === "required" && (
                          <div className="text-danger text-center fs-085 mb-3">
                            شماره شبا نمیتواند خالی باشد
                          </div>
                        )}
                        {errors.shebaNumber?.type === "minLength" && (
                          <div className="text-danger text-center fs-085 mb-3">
                            شماره شبا باید 24 کاراکتر باشد
                          </div>
                        )}
                      </Form.Group>
                      <Row>
                        <Col md="7">
                          <Button
                            variant="primary"
                            type="submit"
                            disabled={isSubmitting}
                            className="w-100 rounded-2"
                          >
                            {isSubmitting && (
                              <Spinner
                                animation="border"
                                variant="warning"
                                size="sm"
                              />
                            )}
                            ذخیره
                          </Button>
                        </Col>
                        <Col md="5" className="ps-0">
                          {" "}
                          <Link
                            to="/profile"
                            className="btn btn-outline-primary w-100 rounded-2"
                          >
                            بازگشت به صفحه قبل
                          </Link>
                        </Col>
                      </Row>
                    </Col>
                    <Col md="2"></Col>
                    <Col md="5">
                      <img src={cardImage} alt="card" />
                    </Col>
                  </Row>
                </form>
              </Card.Body>
            </Card>
          </Container>
        </Container>
      )}
    </>
  );
}
export default Refund;
